<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>
      <Sidebar></Sidebar>
      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">Edit Partner company</h4>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-xlg-9 col-md-12">
              <form
                class="form-horizontal form-material"
                v-on:submit.prevent="submit"
              >
                <div class="form_wrapper_inner">
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company Name</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        v-model="item.title"
                        name=""
                        class="form-control form-control-lg"
                      />
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company Logo</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImage"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValue.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValue"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageData!=null">
                          <img class="preview" :src="picture" />

                          <a @click="onUpload" class="upload-btn">Upload</a>
                        </div>
                        <div v-else>
                          <img class="imagefromdata" :src="item.companylogo" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- hero image -->
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company Hero Image</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImagech"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValuech.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValuech"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageDatach!=null">
                          <img class="preview" :src="picturech" />

                          <a @click="onUploadch" class="upload-btn">Upload</a>
                        </div>
                        <div v-else>
                          <img class="imagefromdata" :src="item.companyheroimage" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End of the hero image -->
                  <!-- social icon -->
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Facebook url</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        name="facebook"
                        v-model="item.facebook"
                        class="form-control form-control-lg"
                      />
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">instagram url</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        name="instagram"
                        v-model="item.instagram"
                        class="form-control form-control-lg"
                      />
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Twiter url</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        type="text"
                        name="twiter"
                        v-model="item.twiter"
                        class="form-control form-control-lg"
                      />
                    </div>
                  </div>
                  <!-- End social icon -->
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Status</label>
                    <div class="col-md-12 border-bottom p-0">
                      <select    @change="onChange($event)" name="type" class="form-control">
                        <option :selected="item.type === 1" value="1">
                          Publish
                        </option>
                        <option :selected="item.type === 0" value="0">
                          UnPublish
                        </option>
                      </select>
                      <!-- <span>Selected: {{ type }}</span>--->
                    </div>
                  </div>
                  <!---- second section ----><span>second section</span>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Image</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImagechssi"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValuechssi.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValuechssi"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageDatachssi!=null">
                          <img class="preview" :src="picturechssi" />

                          <a @click="onUploadchssi" class="upload-btn">Upload</a>
                        </div>
                        <div v-else>
                          <img class="imagefromdata" :src="item.secondsectionimage" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">About </label>
                    <div class="col-md-12 border-bottom p-0">
                      <textarea
                        name="about"
                        v-model="item.about"
                        class="form-control form-control-lg"
                        rows="2"
                      ></textarea>
                    </div>
                  </div>
                <span>Third section</span>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0"
                      >Upload Hero image for third section</label
                    >
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImagechssitsi"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValuechssitsi.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValuechssitsi"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageDatachssitsi!=null">
                          <img class="preview" :src="picturechssitsi" />

                          <a @click="onUploadchssitsi" class="upload-btn">Upload</a>
                        </div>
                        <div v-else>
                          <img class="imagefromdata" :src="item.thirdsectionimage" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Email</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        name="email"
                        type="text"
                        v-model="item.email"
                        class="form-control form-control-lg"
                      />
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Phone</label>
                    <div class="col-md-12 border-bottom p-0">
                      <input
                        name="phone"
                        type="text"
                        v-model="item.phone"
                        class="form-control form-control-lg"
                      />
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Address</label>
                    <div class="col-md-12 border-bottom p-0">
                      <textarea
                        name="address"
                        v-model="item.address"
                        class="form-control form-control-lg"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                  <div class="form-group mb-4 openinghours" >
                      <label class="col-md-12 p-0">Opening Hours</label>
                      <div class="col-md-12">
                          <div class="col-md-6 border-bottom p-0">
                            <input  class="form-control form-control-lg" type="text" value="sunday" readonly>
                          </div>
                          <div class="col-md-6 border-bottom p-0">
                            <input
                                type="text" name="sunday"
                                v-model="item.sunday"
                                class="form-control form-control-lg"
                                />
                          </div>
                      </div>
                      <div class="col-md-12">
                          <div class="col-md-6 border-bottom p-0">
                            <input  class="form-control form-control-lg" type="text" value="Monday" readonly>
                          </div>
                          <div class="col-md-6 border-bottom p-0">
                            <input
                                type="text" name="monday"
                                v-model="item.monday"
                                class="form-control form-control-lg"
                                />
                          </div>
                      </div>
                      <div class="col-md-12">
                          <div class="col-md-6 border-bottom p-0">
                            <input  class="form-control form-control-lg" type="text" value="Tuesday" readonly>
                          </div>
                          <div class="col-md-6 border-bottom p-0">
                            <input
                                type="text" name="tuesday"
                                v-model="item.tuesday"
                                class="form-control form-control-lg"
                                />
                          </div>
                      </div>
                      <div class="col-md-12">
                          <div class="col-md-6 border-bottom p-0">
                            <input  class="form-control form-control-lg" type="text" value="Wednesday" readonly>
                          </div>
                          <div class="col-md-6 border-bottom p-0">
                            <input
                                type="text" name="wednesday"
                                v-model="item.wednesday"
                                class="form-control form-control-lg"
                                />
                          </div>
                      </div>
                      <div class="col-md-12">
                          <div class="col-md-6 border-bottom p-0">
                            <input  class="form-control form-control-lg" type="text" value="Thursday" readonly>
                          </div>
                          <div class="col-md-6 border-bottom p-0">
                            <input
                                type="text" name="thursday"
                                v-model="item.thursday"
                                class="form-control form-control-lg"
                                />
                          </div>
                      </div>
                      <div class="col-md-12">
                          <div class="col-md-6 border-bottom p-0">
                            <input   class="form-control form-control-lg" type="text" value="Friday" readonly>
                          </div>
                          <div class="col-md-6 border-bottom p-0">
                            <input
                                type="text" name="friday"
                                v-model="item.friday"
                                class="form-control form-control-lg"
                                />
                          </div>
                      </div>
                      <div class="col-md-12">
                          <div class="col-md-6 border-bottom p-0">
                            <input   class="form-control form-control-lg"  type="text" value="Saturday" readonly>
                          </div>
                          <div class="col-md-6 border-bottom p-0">
                            <input name="saturday"
                                type="text"
                                v-model="item.saturday"
                                class="form-control form-control-lg"
                                />
                          </div>
                      </div>
                    </div>
                 
                  <div class="card profile-card">
                    <div class="card-body">
                      <div class="form-group mb-4">
                        <label class="col-md-12 p-0">Meta Title</label>
                        <div class="col-md-12 border-bottom p-0">
                          <input
                            type="text"
                            name="meta_title"
                            v-model="item.meta_title"
                            class="form-control form-control-lg"
                          />
                        </div>
                      </div>
                      <div class="form-group mb-4">
                        <label class="col-md-12 p-0">Meta Description</label>
                        <div class="col-md-12 border-bottom p-0">
                          <textarea
                            name="meta_description"
                            v-model="item.meta_description"
                            class="form-control form-control-lg"
                            rows="5"
                          ></textarea>
                        </div>
                      </div>
                      <div class="form-group mb-4">
                        <label class="col-md-12 p-0">Meta Keywords</label>
                        <div class="col-md-12 border-bottom p-0">
                          <input
                            name="meta_keywords"
                            type="text"
                            v-model="item.meta_keywords"
                            class="form-control form-control-lg"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group mb-4 submit_btn_wrapper">
                      <div class="col-sm-12 pl-0 mt-10">
                        <input id="clickbuton" 
                          type="submit"
                          class="btn btn-primary"
                          value="Submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </body>
</template>
<script>
import Header from './../admin-header';
import Footer from './../admin-footer';
import Sidebar from './../admin-sidebar';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import firebase from 'firebase';
import {
	required
}
from 'vuelidate/lib/validators'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {
	db
}
from '../../main'
Vue.use(VueAxios, axios)
export default {
	name: 'Create',
	components: {
		'Header': Header,
		'Sidebar': Sidebar,
		'Footer': Footer,
	},
	data: function() {
		return {
			selected: '',
			slugurl: '',
			item:{},
			options: [],
			imageData: null,
			picture: null,
			uploadValue: 0,
			imageDatach: null,
			picturech: null,
			uploadValuech: 0,
			imageDatachssi: null,
			picturechssi: null,
			uploadValuechssi: 0,
			imageDatachssitsi: null,
			picturechssitsi: null,
			uploadValuechssitsi: 0,
			type: null,
			selecttype: null,
      selecttypej: null,
			companylogo: null,
			companyheroimage: null,
			secondsectionimage: null,
			thirdsectionimage: null,
			ohours: '',
			email: '',
			phone: '',
			address: '',
			title: '',
			about: '',
			facebook: '',
			instagram: '',
			twiter: '',
      sunday: '',
      monday: '',
      tuesday: '',
      wednesday: '',
      thursday: '',
      friday: '',
      ty:'',
      saturday: '',
			meta_title: '',
			meta_description: '',
			meta_keywords: '',
			editor: ClassicEditor,
			editorData: '<p>Content of the editor.</p>',
			editorConfig: {
				// The configuration of the editor.
			}
		}
	},
	created: function() {
	this.getitem();
	},
	validations: {
		title: {
			required
		},
		facebook: {
			required
		},
		address: {
			required
		},
		twiter: {
			required
		},
		instagram: {
			required
		},
		about: {
			required
		},
		email: {
			required
		},
		phone: {
			required
		},
		ohours: {
			required
		},
		type: {
			required
		},
		meta_title: {},
		meta_description: {},
		meta_keywords: {}
	},
	methods: {
         onChange:function(event){
          this.selecttypej =   event.target.value;
        },

	//get item
getitem(){
                var id = this.$route.params.id;

                db.collection('partner').doc(id).get().then((doc) => {

                    this.item = doc.data();
                    //alert(this.item.tuesday);
					this.picture = doc.data().companylogo;
					this.picturech = doc.data().companyheroimage;
					this.picturechssi = doc.data().secondsectionimage;
					this.picturechssitsi = doc.data().thirdsectionimage;
          this.ty = doc.data().type;

                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });


            },

	//end get item

		previewImage(event) {
				this.uploadValue = 0;
				this.picture = null;
				this.imageData = event.target.files[0];
				console.log(this.imageData);
			},
			onUpload() {
				this.picture = null;
      // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageData.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
          }
          return result;
        }
				const storageRef = firebase.storage().ref(imagename+makeid(5)+imageextension).put(this.imageData);
				storageRef.on('state_changed', snapshot => {
					this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValue = 100;
					storageRef.snapshot.ref.getDownloadURL().then((url) => {
						this.picture = url;
            //alert(this.picture);
					});
				});
			},
			previewImagech(eventch) {
				this.uploadValuech = 0;
				this.picturech = null;
				this.imageDatach = eventch.target.files[0];
			},
			onUploadch() {
				this.picturech = null;
        // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageDatach.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         // eslint-disable-next-line no-unused-vars
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
          }
          return result;
        }
				const storageRefch = firebase.storage().ref(imagename+makeid(5)+"."+imageextension).put(this.imageDatach);
				storageRefch.on('state_changed', snapshot => {
					this.uploadValuech = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValuech = 100;
					storageRefch.snapshot.ref.getDownloadURL().then((url) => {
						this.picturech = url;
					});
				});
			},
			previewImagechssi(eventchssi) {
				this.uploadValuechssi = 0;
				this.picturechssi = null;
				this.imageDatachssi = eventchssi.target.files[0];
			},
			onUploadchssi() {
				this.picturechssi = null;
        // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageDatachssi.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         // eslint-disable-next-line no-unused-vars
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
          }
          return result;
        }
				const storageRefchssi = firebase.storage().ref(imagename+makeid(5)+"."+imageextension).put(this.imageDatachssi);
				storageRefchssi.on('state_changed', snapshot => {
					this.uploadValuechssi = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValuechssi = 100;
					storageRefchssi.snapshot.ref.getDownloadURL().then((url) => {
						this.picturechssi = url;
					});
				});
			},
			previewImagechssitsi(eventchssitsi) {
				this.uploadValuechssitsi = 0;
				this.picturechssitsi = null;
				this.imageDatachssitsi = eventchssitsi.target.files[0];
			},
			onUploadchssitsi() {
				this.picturechssitsi = null;
        // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageDatachssitsi.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         // eslint-disable-next-line no-unused-vars
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
          }
          return result;
        }
				const storageRefchssitsi = firebase.storage().ref(imagename+makeid(5)+"."+imageextension).put(this.imageDatachssitsi);
				storageRefchssitsi.on('state_changed', snapshot => {
					this.uploadValuechssitsi = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValuechssitsi = 100;
					storageRefchssitsi.snapshot.ref.getDownloadURL().then((url) => {
						this.picturechssitsi = url;
					});
				});
			},
            
			submit: function(){
        //alert(this.item.sunday);
			if( this.selecttype == ""){
                  this.selecttype = this.ty;
				}else{
				this.selecttype = this.selecttypej;
				}
    // alert(this.selecttype);
			var id = this.$route.params.id;
			var theSlug = this.item.title;
				theSlug = theSlug.toLowerCase();
				theSlug = theSlug.replace(/\s+/g, '-');
				// Replace Ampersand With Dash and Spaces
			theSlug = theSlug.replace(/&/g, "-and-")
				this.slugurl = theSlug;
				var date = new Date().toLocaleString();
				db.collection("partner").doc(id)
                .update({
					title: this.item.title,
					slugurl: this.slugurl,
					facebook: this.item.facebook,
					instagram: this.item.instagram,
					twiter: this.item.twiter,
					email: this.item.email,
					about: this.item.about,
					address: this.item.address,
					phone: this.item.phone,
          sunday: this.item.sunday,
          monday: this.item.monday,
          tuesday: this.item.tuesday,
          wednesday: this.item.wednesday,
          thursday: this.item.thursday,
          friday: this.item.friday,
          saturday: this.item.saturday,
					companylogo: this.picture,
					companyheroimage: this.picturech,
					secondsectionimage: this.picturechssi,
					thirdsectionimage: this.picturechssitsi,
					type: parseInt(this.selecttype),
					meta_title: this.item.meta_title,
					meta_description: this.item.meta_description,
					meta_keywords: this.item.meta_keywords,
					created: date,
					modified: date,
				}).then(() => {
					console.log("Added Successfully!");
					this.$toasted.success('Success, Added Successfully!', {
						icon: 'check',
						//icon : 'error_outline'
					})
					this.$router.push('/partner/index');
				}).catch((error) => {
					console.error("Error writing document: ", error);
				});
			}
	}
}
</script>
<style>
form.form-horizontal.form-material {
  max-height: 90vh;
  overflow-y: scroll;
}
form.form-horizontal.form-material::-webkit-scrollbar {
  width: 10px;
}
form.form-horizontal.form-material::-webkit-scrollbar-track {
  background: #e5e5e5;
}

/* Handle */
form.form-horizontal.form-material::-webkit-scrollbar-thumb {
  background: #03e1bc;
}

/* Handle on hover */
form.form-horizontal.form-material::-webkit-scrollbar-thumb:hover {
  background: #03e1bcc4;
}
.formcta_wrapper div:nth-child(2) p {
  display: flex;
  margin-top: 12px;
  align-items: center;
}

.formcta_wrapper .preview {
  max-width: 150px;
}
.formcta_wrapper div:nth-child(2) p #progress {
  margin-left: 10px;
}
.formcta_wrapper button {
  display: block;
  border: none;
  background: #03e1bc;
  padding: 2px 20px;
  font-size: 12px;
  border-radius: 15px;
  margin-top: 10px;
  color: #fff;
}
.submit_btn_wrapper {
  padding-bottom: 40px;
  padding-left: 20px;
}
.upload-btn {
    background: #03e1bc;
    padding: 6px 25px;
    border-radius: 50px;
    color: #fff;
	cursor: pointer;
}
.formcta_wrapper .preview {
    max-width: 150px;
    display: block;
    margin-bottom: 30px;
}
.imagefromdata {
    max-width: 250px;
}

.openinghours > div {
    display: flex;
    align-items: center;
}

.openinghours > div > div {
    padding: 10px !important;
}

</style>
